/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type GetAgentConnectorRequest = {
  /**
   * The agent ID.
   */
  id: string;
  /**
   * The connector ID.
   */
  connectorId: string;
  /**
   * Optional external end-user identifier forwarded by the API gateway.
   */
  xOnBehalfOf?: string | undefined;
};

/** @internal */
export const GetAgentConnectorRequest$inboundSchema: z.ZodType<
  GetAgentConnectorRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  id: z.string(),
  connectorId: z.string(),
  "X-On-Behalf-Of": z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    "X-On-Behalf-Of": "xOnBehalfOf",
  });
});
/** @internal */
export type GetAgentConnectorRequest$Outbound = {
  id: string;
  connectorId: string;
  "X-On-Behalf-Of"?: string | undefined;
};

/** @internal */
export const GetAgentConnectorRequest$outboundSchema: z.ZodType<
  GetAgentConnectorRequest$Outbound,
  z.ZodTypeDef,
  GetAgentConnectorRequest
> = z.object({
  id: z.string(),
  connectorId: z.string(),
  xOnBehalfOf: z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    xOnBehalfOf: "X-On-Behalf-Of",
  });
});

export function getAgentConnectorRequestToJSON(
  getAgentConnectorRequest: GetAgentConnectorRequest,
): string {
  return JSON.stringify(
    GetAgentConnectorRequest$outboundSchema.parse(getAgentConnectorRequest),
  );
}
export function getAgentConnectorRequestFromJSON(
  jsonString: string,
): SafeParseResult<GetAgentConnectorRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => GetAgentConnectorRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GetAgentConnectorRequest' from JSON`,
  );
}
